import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Input, Button, Dropdown } from 'semantic-ui-react';
import { saveDataToCbp, createActorRef } from "./apiCalls/index";
import { decamelize, initialValues } from "./util";
import { toast } from "../../commonComponents/Toast";
import { intializeBrokerQryFunc } from './actions/qryInputActions'; 
import _ from 'lodash'
import store from './store';
import { countryList, canadianStates } from './countryList';
export class MidEditableOutput extends Component {    
    constructor(props) {
        super(props);
        
        this.state = {
            "openMid": "",
            "mfData": this.initMfData(),
            "startingMfData": this.initMfData(),
            addManuallyClicked: false
        }
        this.saveData = this.saveData.bind(this)
        this.savingComplete = this.savingComplete.bind(this)
        this.savingFailed = this.savingFailed.bind(this)
        this.addManuallyClicked = this.addManuallyClicked.bind(this)
        this.resetMfState = this.resetMfState.bind(this)
        this.saveToActorRef = this.saveToActorRef.bind(this)
    } 
    initMfData() {
        return JSON.parse(JSON.stringify({
            "actorId": "",
            "mid": "",
            "firmName": "",
            "street": "",
            "unstructuredAddress": "",
            "city": "",
            "state": "",
            "countryCode": "",
            "zip": "",
            "contactName":"",
            "contactEmail": "",
            "contactPhone": ""
        }));
    }
    
    componentDidMount(){
        this.validateMfData(this.state.mfData)
        //console.log("data =======", this.props.data);
    }
    
    preFillData(data){
        let mfData = this.initMfData();
        mfData["mid"] = data.mid || "";
        mfData["firmName"] = data.name || "";
        if(data.address){
            let sNum  = data.address.STREET_NUMBER || "";
            let sName = data.address.STREET_NAME || "";
            mfData["street"] = (sNum.trim()+" "+sName.trim()).trim() || "";
            mfData["unstructuredAddress"] = data.address.UNSTRUCTURED_STREET_ADDRESS || "";
            mfData["state"] = data.address.COUNTRY_SUB_ENTITY || "";
            mfData["city"] = data.address.CITY || "";
            mfData["countryCode"] = data.address.COUNTRY_CODE || data.address.COUNTRY || "";
            mfData["zip"] = data.address.POSTAL_CODE || "";
        }
        if(data.firmName && data.street){
            mfData = data
        }
        this.setState({"mfData": mfData, startingMfData:JSON.parse(JSON.stringify(mfData))}, ()=>{
            this.validateMfData(this.state.mfData);
        });
        
        
    }

    componentDidUpdate(prevProps, nextProps){
        let mfData = this.initMfData();
        if(JSON.stringify(prevProps.selectedResultList)!==JSON.stringify(this.props.selectedResultList)){
            mfData["actorId"] = this.props.selectedResultList.actorId || "";
            mfData["mid"] = this.props.selectedResultList.mid || "";
            mfData["firmName"] = this.props.selectedResultList.name
            mfData["contactName"] = this.props.selectedResultList.contactName || ""
            mfData["contactEmail"] = this.props.selectedResultList.email || ""
            mfData["contactPhone"] = this.props.selectedResultList.primaryphone || ""
            let streetNum = "";
            let streetName = "";
            this.props.selectedResultList.addressinfo.map((item)=>{
                if(item.type === 'STREET_NUMBER'){
                    streetNum = item.information || "";
                }
                if(item.type === 'STREET_NAME'){
                    streetName = item.information || "";
                    mfData["street"] = streetNum.trim() +" "+ streetName.trim();
                }
                if(item.type === 'CITY'){
                    mfData["city"] = item.information;
                } 
                if(item.type === 'COUNTRY_SUB_ENTITY'){
                    mfData["state"] = item.information;
                }
                if (item.type === 'COUNTRY' && item.information) {
                    mfData["country"] = item.information;
                } 
                if(item.type === 'UNSTRUCTURED_STREET_ADDRESS'){
                    mfData["unstructuredAddress"] = item.information;
                }
                if(item.type === 'COUNTRY_CODE'){
                    mfData["countryCode"] = item.information;
                } 
                if(item.type === "POSTAL_CODE"){
                    mfData["zip"] = item.information;
                }
            })
            if(["CA","CANADA"].includes((mfData["countryCode"]+"").toUpperCase())){
                mfData["state"] = (
                    canadianStates.find(state=>mfData["state"] == state["shorthand"])
                    && canadianStates.find(state=>mfData["state"] == state["shorthand"]).id 
                ) || mfData["state"]
            }
            this.setState({"mfData": mfData, "updated": true}, ()=>{
                this.validateMfData(this.state.mfData);
            });
            
            if(!this.state.updated ){
                this.setState({startingMfData: JSON.parse(JSON.stringify(mfData))})
            }
        }
        if(!this.state.updated && this.detailResult && this.detailResult.records){
            if(this.resultData.manufacturerDetails){
                mfData =this.resultData.manufacturerDetails;
               // this.setMidWhenError();
            }else{
                let mid = "";
                this.detailResult.records.map((item)=>{
                    item.values && item.values.map((_item)=>{
                        if(_item.key == 'mid'){
                            mid = _item.value;
                        }
                        // if(item.recordId === "$7"){
                        //     if(_item.key == "narrMsg" && _item.value == 'MID ALREADY EXISTS'){
                        //         toast.warning(_item.value+", Try MID Query!");
                        //         let initData = initialValues("MID");
                        //         store.dispatch(intializeBrokerQryFunc(initData));
                        //         setTimeout(()=>{
                        //             if(document.getElementById("Mid-Num")){
                        //                 document.getElementById("Mid-Num").value = mid || "";
                        //             }
                        //         },0)
                        //     }
                        // }
                        
                        if(_item.key == 'isoCountryCode'){
                            mfData['countryCode'] =_item.value; 
                        }else{
                            mfData[_item.key] =_item.value;
                        }
                    })
                })
            }
            this.setState({"mfData": mfData, "updated": true}, ()=>{
                this.validateMfData(this.state.mfData);
            });
            if(!this.state.updated ){
                this.setState({startingMfData: JSON.parse(JSON.stringify(mfData))})
            }
        }
    }
    
    setMidWhenError(){
       let mid = "";
        this.detailResult.records.map((item)=>{
            item.values && item.values.map((_item)=>{
                if(_item.key == 'mid'){
                    mid = _item.value;
                }
                if(item.recordId === "$7"){
                    if(_item.key == "narrMsg" && _item.value == 'MID ALREADY EXISTS'){
                        toast.warning(_item.value+", Try MID Query!");
                        let initData = initialValues("MID");
                        initData.saveTo = null;
                        setTimeout(()=>{store.dispatch(intializeBrokerQryFunc(initData))},0);
                        setTimeout(()=>{
                            if(document.getElementById("Mid-Num")){
                                document.getElementById("Mid-Num").value = mid || "";
                            }
                        }, 2000)
                    }
                }
                
            })
        })
    }
    resetMfState() {
        this.setState({"mfData": this.initMfData()});
    }
    
    addManuallyClicked(mid) {
        this.setState({"loadingAddManually": true})
        if(!mid){
            this.resetMfState();
        }
    }
    validateMfData(mfData) {
        
        let  validateChinaZip = (address, name)=>{
            console.log('address, name: ', address, name);
            if(address.COUNTRY && address.COUNTRY.toUpperCase() === "CHINA" && name === "MANUFACTURER"){
              if(!address.POSTAL_CODE || address.POSTAL_CODE.length === 0){
                return "Field Required"
              }
              else if(!(/^[0-9]{6}$/).test(address.POSTAL_CODE)){
                return "Field format must be 6 digits - NNNNNN"
              }
            }
            return "";
          }

        let errors = {}
        if(!mfData.firmName){
            errors["firmName"] = "Firm/Manufacturer name is missing";
        }
        if(!mfData.street){
            errors["street"] = "Street Address is missing";
        }else if(mfData.street.length>43){
            errors["street"] = "Street Address cannot be longer than 43 characters.";
        }
        if(!mfData.city){
            errors["city"] = "City is missing";
        }
        if(!mfData.countryCode){
            errors["country"] = "Country code is missing";
        }
        if(mfData.countryCode && mfData.countryCode.length!==2){
            errors["country"] = "Country code length should be 2";
        }
        if(mfData.countryCode == 'CA' && 
        !["XA", "XB", "XC", "XM", "XN", "XO", "XP", "XQ", "XS", "XT", "XV", "XW", "XY"].includes(mfData.state)){
            errors["state"] = "Canadian province is missing";
        }
        if((mfData.countryCode === 'US' || mfData.countryCode === 'CA') && !mfData.zip){
            errors["zip"] = "Postal code is missing";
        }
        let chinaError = validateChinaZip({COUNTRY:mfData.countryCode=="CN"?"CHINA":mfData.countryCode,POSTAL_CODE:mfData.zip},"MANUFACTURER")
        if(chinaError){
            errors["zip"] = chinaError;
        }
        this.setState({"errors": errors})
        return errors;
    }

    saveToActorRef(saveToActorRefOnly) {
        let mfData = this.state.mfData;
        this.setState({"savingData": true})
        createActorRef(mfData, this.props.loggedInUserEmail, this.props.savedInContextOf).then((res)=>{
           if(_.get(res, "data.eventMessage.actorId")){
               toast.success("Data saved successfully!");
               this.setState({"savingData": false}, ()=>{
                    if(!saveToActorRefOnly){
                        this.props.set_MF_Form_Data(this.state.mfData);
                    }
                    this.props.closeModal();
               });
           }else{
                toast.error("Data not saved!");
                this.setState({"savingData": false});
           } 
        }).catch((err)=>{
            this.setState({"savingData": false})
        });
    }

    saveData() {
        let mfData = this.state.mfData;
        let err = this.validateMfData(mfData);
        setTimeout(()=>{
            this.setState({"savingData": true})
            if(_.isEmpty(err)){
                saveDataToCbp(mfData, this.props.brokerId, this.props.shipmentId, this.savingComplete, this.savingFailed).then((response)=>{
                    let initData = initialValues("MID")
                    initData.saveTo = "createActorRefOnly2";
                    store.dispatch(intializeBrokerQryFunc(initData)); 
                    this.setState({"savingData": false})
                }).catch((err)=>{
                    this.setState({"savingData": false})
                    toast.error("Data not saved!! "+(err?err:"")); 
                })
            }else{
              toast.warning("Please correct or fill in the highlighted fields!  "+JSON.stringify(err))  
              this.setState({"savingData": false})
            }
        },10)
    }

    
    savingComplete(mid){
        let mfData = this.state.mfData;
        if(mid){
            mfData.mid = mid;
            this.setState({"mfData": mfData});
        }
        this.setState({"dataSaved": true})
    }

    savingFailed(response){
        toast.error("Data not saved to CBP.")
        this.setState({"dataSaved": false})
    }

    onChange(field, event){
        setTimeout(()=>{document.getElementById("validateMFData") &&document.getElementById("validateMFData").click()},5)
        let mfData = this.state.mfData;
        let value = event.target.value;
        let id = event.target.id;
        if(value && id !== 'contactEmail'){
            value = value.toUpperCase();
        }
        mfData[field] = value;
        this.setState({"mfData": mfData})
    }

    render(){
        let isInvalidMid = false;
        let midAlreadyExist = false;
        let saveTo = this.props.saveTo;
        this.resultData = this.props.qryOutput.responseParams;
        this.detailResult = this.resultData.detail;

        if(this.detailResult && this.detailResult.records){
            isInvalidMid = (_.get(this.detailResult, "records[2].values[0].value") === 'INVALID MANUFACTURER NUMBER'); 
            let mid = "";
            if(!isInvalidMid){
                this.detailResult.records && this.detailResult.records.map((item)=>{
                    item.values && item.values.map((_item)=>{
                        if(item.recordId === "$5" && _item.key == "updateStatus" && _item.value == 'E'){
                            isInvalidMid = true;
                        }
                        if(_item.key == 'mid'){
                            mid = _item.value;
                        }
                        if(item.recordId === "$7" && _item.key == "narrMsg" && _item.value == 'MID ALREADY EXISTS'){
                            midAlreadyExist = true;
                        }
                    })
                })
            }
        }
       
    return (
        <React.Fragment> 
            <style type="text/css">{`
            .midaddtablex .outputList-row {
                flex-wrap:nowrap !important;
            }
            `}</style>
            <div id={`${this.props.qryInput.qryType.toLowerCase()}Output`} className={`outputData midaddtablex ${this.props.qryInput.qryType.toLowerCase()}Output`}>
            {
                isInvalidMid && 
                <Grid className={`primaryOutput`}>  
                {
                    (this.detailResult && this.detailResult.records) && this.detailResult.records.map((item)=>(
                        
                        item.values && item.values.map((_item)=>(
                            <Grid.Row className={`outputList-row`} key={'xaaa'+item.key}>
                                <Grid.Column className="keyName" width={5}>{decamelize(_item.key)}</Grid.Column>
                                <Grid.Column width={1}></Grid.Column>
                                <Grid.Column className="keyValue" width={10}>{_item.value}</Grid.Column>
                            </Grid.Row>
                        ))
                          
                   )) 
            }
            </Grid>
            }
            {
                !isInvalidMid && saveTo!=null && <Grid className={`primaryOutput`} columns={3}>
                {
                          
                          <React.Fragment>
                              <Grid.Row className={`outputList-row`} key={'xaaa-mf-detail'}>
                                 <Grid.Column className="keyName" width={16} style={{"textAlign":"center"}}>MANUFACTURER'S DETAILS</Grid.Column>
                             </Grid.Row>
                              <Grid.Row className={`outputList-row`} key={'xaaa-mid'}>
                                 <Grid.Column className="keyName" width={5}>Manufacturer Id</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     {
                                         this.state.openMid ? 
                                         <Input 
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.mid') ? " errorMsg": ""}`} 
                                         name={`mid`} 
                                         id={`mid`} 
                                         value={this.state.mfData.mid}
                                         onChange={(value)=> {
                                             if(value){
                                                this.onChange("mid", value)
                                             }
                                         }}  
                                     /> :
                                     this.state.mfData.mid
                                     }</Grid.Column>
                             </Grid.Row>
                            <Grid.Row className={`outputList-row`} key={'xaaa-firmName'}>
                                 <Grid.Column className="keyName" width={5}>Firm Name</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.firmName') ? " errorMsg": ""}`} 
                                         name={`firmName`} 
                                         id={`firmName`} 
                                         //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                         value={this.state.mfData.firmName}
                                         onChange={(value)=> {
                                             if(value){
                                                 
                                                this.onChange("firmName", value)
                                             }
                                         }}  
                                     />
                                     </Grid.Column>
                                
                             </Grid.Row>
                             <Grid.Row className={`outputList-row`} key={'xaaa-streetAddress'}>
                                 <Grid.Column className="keyName" width={5}>Street Address</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                            if(value){
                                                 
                                                this.onChange("street", value)
                                            }
                                         }}
                                         //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.street') ? " errorMsg": ""}`} 
                                         name={`street`} id={`street`} value={this.state.mfData.street}
                                         
                                     /></Grid.Column>
                             </Grid.Row>
                             <Grid.Row className={`outputList-row`} key={'xaaa-unstructureStreetAddress'}>
                                 <Grid.Column className="keyName" width={5}>Address 2</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                            if(value){
                                                 
                                                this.onChange("unstructuredAddress", value)
                                            }
                                         }}
                                         //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.unstructuredAddress') ? " errorMsg": ""}`} 
                                         name={`unstructuredAddress`} id={`unstructuredAddress`} 
                                         value={this.state.mfData.unstructuredAddress}
                                         
                                     /></Grid.Column>
                             </Grid.Row>
                            <Grid.Row className={`outputList-row`} key={'xaaa-city'}>
                                 <Grid.Column className="keyName" width={5}>City</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                            if(value){
                                                 
                                                this.onChange("city", value);
                                            }
                                         }} 
                                         //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.city') ? " errorMsg": ""}`} 
                                         name={`city`} id={`city`} value={this.state.mfData.city}
                                         
                                         /></Grid.Column>
                                
                             </Grid.Row>
                             {
                                   this.state.mfData.countryCode !== "CA" && 
                                 <Grid.Row className={`outputList-row`} key={'xaaa-state'}>
                                 <Grid.Column className="keyName" width={5}>State</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                            if(value){
                                                 
                                                this.onChange("state", value);
                                            }
                                         }}
                                         //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                         className={`keyValueInput upper`} 
                                         name={`state`} id={`state`} value={this.state.mfData.state}
                                          
                                        /></Grid.Column>
                                
                             </Grid.Row>
                            }
                              <Grid.Row className={`outputList-row`} key={'xaaa-country-code'}>
                                 <Grid.Column className="keyName" width={5}>ISO Country Code</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                    <select name={`countryCode`} id={`countryCode`} 
                                        onChange={(value)=> {
                                            if(value){
                                                    
                                                this.onChange("countryCode", value);
                                            }
                                        }} 
                                        //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                        className={`keyValueInput upper ${_.get(this.state, 'errors.country') ? " errorMsg": ""}`} 
                                        
                                        style={{"width": "91%", "height": "25px"}} 
                                        placeholder="Country" 
                                        value={this.state.mfData.countryCode}>
                                            <option value=''>Country</option>
                                            {
                                                countryList.map((item)=>{
                                                        return (
                                                        <option key={item.value+' - '+item.text} value={item.value} selected = {item.value === this.state.mfData.countryCode?' selected': ''}>
                                                            {item.value+' - '+item.text}
                                                        </option>
                                                        )
                                                })
                                            }
                                        </select>
                                     {/* <Input 
                                         maxLength={2}   
                                         onChange={(value)=> {
                                            if(value){
                                                 
                                                this.onChange("countryCode", value);
                                            }
                                         }}
                                         disabled={saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2'}
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.country') ? " errorMsg": ""}`} 
                                         name={`countryCode`} id={`countryCode`} 
                                         value={this.state.mfData.countryCode}
                                         
                                         /> */}
                                </Grid.Column>
                             </Grid.Row>
                             {
                                 this.state.mfData.countryCode == "CA" && 
                                 <Grid.Row className={`outputList-row`} key={'xaaa-canadian-province'}>
                                 <Grid.Column className="keyName" width={5}>Canadian Province</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                 <select name={`state`} id={`state`} 
                                        onChange={(value)=> {
                                            if(value){
                                                    
                                                this.onChange("state", value);
                                            }
                                        }} 
                                        //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                        className={`keyValueInput upper ${_.get(this.state, 'errors.country') ? " errorMsg": ""}`} 
                                        
                                        style={{"width": "91%", "height": "25px"}} 
                                        placeholder="Canadian Province" 
                                        value={this.state.mfData.state}>
                                            <option value=''>Canadian Province</option>
                                            {
                                                canadianStates.map((item)=>{
                                                        return (
                                                        <option value={item.value} selected = {item.value === this.state.mfData.state?' selected': ''}>
                                                            {item.value+' - '+item.text}
                                                        </option>
                                                        )
                                                })
                                            }
                                        </select>
                                     {/* <Dropdown 
                                         maxLength={2}   
                                         onChange={(value)=> {
                                            if(value){ 
                                                this.onChange("state", value);
                                            }
                                         }}
                                         disabled={saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2'}
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.state') ? " errorMsg": ""} qryDropdown`} 
                                         name={`state`} id={`state`} 
                                         value={this.state.mfData.state}
                                         text={this.state.mfData.state}
                                         fluid
                                         selection
                                         search
                                         options={canadianStates}
                                         /> */}
                                </Grid.Column>
                             </Grid.Row>
                            }
                             <Grid.Row className={`outputList-row`} key={'xaaa-zip'}>
                                 <Grid.Column className="keyName" width={5}>Zip</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                            if(value){
                                                 
                                                this.onChange("zip", value)
                                            }
                                         }}
                                         //disabled={(saveTo === 'createActorRefOnly' || saveTo === 'createActorRefOnly2')}
                                         className={`keyValueInput upper ${_.get(this.state, 'errors.zip') ? " errorMsg": ""}`} 
                                         name={`zip`} id={`zip`} 
                                         value={this.state.mfData.zip}
                                         
                                         /></Grid.Column>
                                
                             </Grid.Row>
                              <Grid.Row className={`outputList-row`} key={'xaaa-contactName'}>
                                 <Grid.Column className="keyName" width={5}>Contact Name</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                            if(value){
                                                 
                                                this.onChange("contactName", value)
                                            }
                                         }}
                                         disabled={true}
                                         className={`keyValueInput upper`} name={`contactName`} id={`contactName`} value={this.state.mfData.contactName}
                                         
                                         /></Grid.Column>
                                
                             </Grid.Row>
                             <Grid.Row className={`outputList-row`} key={'xaaa-email'}>
                                 <Grid.Column className="keyName" width={5}>Contact Email</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                             this.onChange("contactEmail", value)
                                         }}
                                         className={`keyValueInput`} name={`contactEmail`} id={`contactEmail`} value={this.state.mfData.contactEmail}/></Grid.Column>
                                
                             </Grid.Row>
                             <Grid.Row className={`outputList-row`} key={'xaaa-phone'}>
                                 <Grid.Column className="keyName" width={5}>Phone</Grid.Column>
                                 <Grid.Column width={1}></Grid.Column>
                                 <Grid.Column className="keyValue" width={10}>
                                     <Input 
                                         onChange={(value)=> {
                                             this.onChange("contactPhone", value)
                                         }}
                                         className={`keyValueInput upper`} name={`phone`} id={`phone`} value={this.state.mfData.contactPhone}
                                         
                                         /></Grid.Column>
                                
                             </Grid.Row> 
                          </React.Fragment>
                     
                 } 
             </Grid>
            }
            
        </div>
        {
            this.props.userType!=='OPS_USER' && !this.props.saveTo && <div style={{"width": "100%", "fontWeight":"bold", "textAlign":"center", "margin":"5px"}}>OR</div>  
        }
        <div style={{"display": "flex", "marginTop":"10px", "marginBottom":"10px",
  justifyContent: "center"}}>
        {
            (this.props.userType!=='OPS_USER' && !midAlreadyExist && (!this.props.saveTo || (isInvalidMid && !this.state.addManuallyClicked))) && <div>
                <Button primary 
                    loading={this.state.addManuallyClicked}
                    onClick={()=>{
                        this.addManuallyClicked();
                        this.setState({"addManuallyClicked": true});
                        let initData = initialValues("MID")
                        initData.saveTo = "cbpAndCreateActor";
                        store.dispatch(intializeBrokerQryFunc(initData)); 
                        if(!this.props.saveToActorRefOnly){
                            this.preFillData(this.props.data)
                        }
                }}>Add Manually</Button>
            </div>
        }
        {
            (this.props.userType!=='OPS_USER' && midAlreadyExist && isInvalidMid && !this.state.addManuallyClicked) && <div style={{"display":"block"}}>
                <label style={{"fontSize":"12px", "textDecoration":"none", "paddingBottom":"15px"}}><b>Note: This (Add MID Manually) will not call Save CBP but will save to the database</b><br /></label>
                <Button primary 
                    loading={this.state.addManuallyClicked}
                    style={{"marginTop":"10px"}}
                    onClick={()=>{
                        this.setState({"openMid": true});
                        this.addManuallyClicked();
                        this.setState({"addManuallyClicked": true});
                        let initData = initialValues("MID")
                        initData.saveTo = "createActorRefOnly3";
                        store.dispatch(intializeBrokerQryFunc(initData)); 
                        this.preFillData(this.state.mfData)
                }}>Add MID Manually</Button> 0R <Button primary 
                loading={this.state.midCbpQueryClicked}
                onClick={()=>{
                    this.setState({"midCbpQueryClicked": true})
                    let initData = initialValues("MID");
                    initData.saveTo = null;
                    store.dispatch(intializeBrokerQryFunc(initData));
                    setTimeout(()=>{
                        if(document.getElementById("Mid-Num")){
                            document.getElementById("Mid-Num").value = this.state.mfData.mid || "";
                        }
                    }, 5000)
            }}>MID CBP Query</Button></div>
        }
        
        {
          (saveTo == 'createActorRefOnly' || saveTo == 'createActorRefOnly2' || saveTo === 'createActorRefOnly3') && !isInvalidMid && !this.state.dataSaved && <div>
            <Button 
                loading={this.state.savingData}
                primary onClick={()=>{
                    this.props.callbackAfterCbp && this.props.callbackAfterCbp(this.props.qryOutput);
                    this.saveToActorRef(this.props.saveToActorRefOnly); 
                }}>{this.state.savingData ? 'Saving...': ((this.props.saveToActorRefOnly || saveTo === 'createActorRefOnly3') ? 'Save' : 'Save & Select')}</Button>
            </div>
        }
        {
           (saveTo === 'cbpAndCreateActor' && this.state.addManuallyClicked && !this.state.dataSaved) && <div>
            {Object.keys(this.state.errors||{}).map((kkkkey,ii)=>{
                return(<div style={{color:'red'}} key={`${kkkkey}xx${ii}`}>
                    {(kkkkey||"").replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}: {this.state.errors[kkkkey]}
                </div>)
            })}
            <br/>
            <Button 
                style={{"marginLeft":"10px"}}
                loading={this.state.savingData}
                primary onClick={()=>{
                    this.saveData(); 
                }}>{this.state.savingData ? 'Saving...': 'Add Manufacturer'}</Button>
                <Button
                 onClick={()=>{
                    this.resetMfState();
                }}>Clear</Button>
            </div>
        }
        <input type="hidden" onClick={()=>{this.validateMfData(this.state.mfData)}} id="validateMFData"/>
        
        
        {/* {
           !isInvalidMid && this.state.dataSaved && 
            <div>
                <Button primary onClick={()=>{
                    let errors = this.validateMfData(this.state.mfData);
                    if(!_.isEmpty(errors)){
                        this.props.set_MF_Form_Data(this.state.mfData)
                        this.props.closeModal();
                    }
                }}>Select</Button>
            </div>
        } */}
        </div>
        </React.Fragment>
    )
 }
}

const mapStateToProps = (state, props) => {
     let _state = state.QryInput || store.getState().QryInput;
     return ({
     requestId: _state.requestid,
     mockResponseRequired: _state.mockResponseRequired,
     loading: _state.loading,
     qryInput: _state.qryInput,
     qryOutput: _state.qryOutput,
     saveTo: _state.saveTo
 })
 }
 
 const mapDispatchToProps = {

}

  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MidEditableOutput)
    